import { useMutation } from "@tanstack/react-query";

import { api } from "@/lib/api";
import type { ReportDownloadInput, ReportKind } from "@/types/reports";

/**
 * Generate + download a branded report PDF. The server streams the PDF and
 * `api.download` saves it via a temporary `<a download>` link. One hook per
 * catalog kind; the body carries only the params that report reads.
 */
export function useDownloadReport(kind: ReportKind) {
  return useMutation({
    mutationFn: (body: ReportDownloadInput) =>
      api.download(`/api/reports/${kind}/download`, body),
  });
}
